import { Layout, CheckForApplicationUpdate } from 'react-admin';
import { ConfigProvider } from 'antd';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import { AppMenu } from './AppMenu';
import { AppBar } from './AppBar';
import { useSettingsContext } from '@providers';
import { useIsFirstRender } from '@hooks';
import cls from './layout.module.css';

export const AppLayout = (props: any) => {
  const location = useLocation();
  const { refreshNotifications } = useSettingsContext();
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (isFirstRender) return;

    refreshNotifications();
  }, [location.pathname]);

  return (
    <ConfigProvider>
      <Layout appBar={AppBar} menu={AppMenu} className={cls.layout}>
        {props.children}
        <CheckForApplicationUpdate />
      </Layout>
    </ConfigProvider>
  );
};
